var _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _path8, _circle, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakeAPhotoFromInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5L19.5 10L15.5227 6.46463C15.2088 6.18561 14.754 6.13245 14.3842 6.33156L3.18338 12.3628C2.59359 12.6804 2.47671 13.4767 2.95037 13.9504L6.5 17.5Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5L19.5 25L15.5392 28.5207C15.2173 28.8069 14.7482 28.8547 14.3751 28.6395L3.20066 22.1927C2.60976 21.8518 2.52614 21.0323 3.03602 20.5791L6.5 17.5Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17.5L20 10L23.9773 6.46463C24.2912 6.18561 24.746 6.13245 25.1158 6.33156L36.3166 12.3628C36.9064 12.6804 37.0233 13.4767 36.5496 13.9504L33 17.5Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17.5L20 25L23.9773 28.5354C24.2912 28.8144 24.746 28.8675 25.1158 28.6684L36.3166 22.6372C36.9064 22.3196 37.0233 21.5233 36.5496 21.0496L33 17.5Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 39.5V25L15.5188 28.5388C15.2068 28.8162 14.7554 28.8705 14.3865 28.6752L6.5 24.5V31.4224C6.5 31.7798 6.69072 32.11 7.00028 32.2886L19.5 39.5Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 31.4224V25L25.0723 28.7139C24.7234 28.8883 24.305 28.844 24.0004 28.6003L19.5 25V39.5L31.9997 32.2886C32.3093 32.11 32.5 31.7798 32.5 31.4224Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2222_4264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1324 26C34.4299 26 33.7788 26.3686 33.4174 26.971L32.8174 27.971C32.8116 27.9807 32.8059 27.9903 32.8003 28H30C28.8954 28 28 28.8954 28 30V40C28 41.1046 28.8954 42 30 42H44C45.1046 42 46 41.1046 46 40V30C46 28.8954 45.1046 28 44 28H41.1997C41.1941 27.9903 41.1884 27.9807 41.1826 27.971L40.5826 26.971C40.2212 26.3686 39.5701 26 38.8676 26H35.1324Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1324 26C34.4299 26 33.7788 26.3686 33.4174 26.971L32.8174 27.971C32.8116 27.9807 32.8059 27.9903 32.8003 28H30C28.8954 28 28 28.8954 28 30V40C28 41.1046 28.8954 42 30 42H44C45.1046 42 46 41.1046 46 40V30C46 28.8954 45.1046 28 44 28H41.1997C41.1941 27.9903 41.1884 27.9807 41.1826 27.971L40.5826 26.971C40.2212 26.3686 39.5701 26 38.8676 26H35.1324Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4174 26.971L34.2749 27.4855V27.4855L33.4174 26.971ZM32.8174 27.971L33.6749 28.4855L33.6749 28.4855L32.8174 27.971ZM32.8003 28V29H33.377L33.6658 28.5009L32.8003 28ZM41.1997 28L40.3342 28.5009L40.623 29H41.1997V28ZM41.1826 27.971L42.0401 27.4565L42.0401 27.4565L41.1826 27.971ZM40.5826 26.971L41.4401 26.4565V26.4565L40.5826 26.971ZM34.2749 27.4855C34.4556 27.1843 34.7811 27 35.1324 27V25C34.0786 25 33.1021 25.5529 32.5599 26.4565L34.2749 27.4855ZM33.6749 28.4855L34.2749 27.4855L32.5599 26.4565L31.9599 27.4565L33.6749 28.4855ZM33.6658 28.5009C33.6688 28.4958 33.6718 28.4906 33.6749 28.4855L31.9599 27.4565C31.9514 27.4707 31.943 27.4849 31.9348 27.4991L33.6658 28.5009ZM30 29H32.8003V27H30V29ZM29 30C29 29.4477 29.4477 29 30 29V27C28.3431 27 27 28.3431 27 30H29ZM29 40V30H27V40H29ZM30 41C29.4477 41 29 40.5523 29 40H27C27 41.6569 28.3431 43 30 43V41ZM44 41H30V43H44V41ZM45 40C45 40.5523 44.5523 41 44 41V43C45.6569 43 47 41.6569 47 40H45ZM45 30V40H47V30H45ZM44 29C44.5523 29 45 29.4477 45 30H47C47 28.3431 45.6569 27 44 27V29ZM41.1997 29H44V27H41.1997V29ZM40.3251 28.4855C40.3282 28.4906 40.3312 28.4957 40.3342 28.5009L42.0652 27.4991C42.057 27.4849 42.0486 27.4707 42.0401 27.4565L40.3251 28.4855ZM39.7251 27.4855L40.3251 28.4855L42.0401 27.4565L41.4401 26.4565L39.7251 27.4855ZM38.8676 27C39.2189 27 39.5444 27.1843 39.7251 27.4855L41.4401 26.4565C40.8979 25.5529 39.9214 25 38.8676 25V27ZM35.1324 27H38.8676V25H35.1324V27Z",
    fill: "#2A2E3C",
    mask: "url(#path-7-inside-1_2222_4264)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35,
    r: 3,
    fill: "#087E38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5294 20.5749L21.5 25.5L24.5 28.5L35.5 22.5L34.0873 21.0873C33.1462 20.1462 31.6977 19.9376 30.5294 20.5749Z",
    fill: "#087E38"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14L6.5 17L17.5 10.5L15.0222 8.4352C14.707 8.17254 14.2634 8.12906 13.9032 8.32553L3.5 14Z",
    fill: "#087E38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9778 8.4352L21.5 10.5L33 17L35.5 14L25.0968 8.32553C24.7366 8.12906 24.293 8.17254 23.9778 8.4352Z",
    fill: "#087E38"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.5L5.44503 20.555C4.97296 21.027 5.08719 21.8203 5.67328 22.14L15.5 27.5L18.5 25L7.5 18.5Z",
    fill: "#087E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAPhotoFromInside);
export default __webpack_public_path__ + "static/media/take_a_photo_from_inside.0610e353af70c3070aa89cb65d699b2d.svg";
export { ForwardRef as ReactComponent };